<template>
  <gkFormText
    class="img-captcha-text"
    validity
    :group="group"
    :field="field"
    type="text"
    :size="size"
    :color="color"
    :placeholder="placeholder"
    :length="length"
    :rule="mergeRule"
    :disabled="disabled"
    :customRule="mergeCustomRule"
    v-model="currentValue"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <img slot="end" :src="captchaUrl" alt="点击刷新" @click="refresh" />
  </gkFormText>
</template>

<script>
import VueTypes from 'vue-types'

import utils from '../../utils'

import gkFormText from 'gkui/form/FormText'
import formProps from 'gkui/form/form.props'
import validityProps from 'gkui/form/validity.props'

export default {
  name: 'img-captcha',
  components: {
    gkFormText
  },
  props: Object.assign({}, formProps, validityProps, {
    field: VueTypes.string.def('captcha'),
    placeholder: VueTypes.string.def('请输入验证码'),
    length: VueTypes.number.def(4),
    src: String,
    rule: VueTypes.oneOfType([String, Array]).def([])
  }),
  data () {
    return {
      currentValue: this.value,
      guid: utils.guid()
    }
  },
  computed: {
    mergeRule () {
      let rule = ['required', {imgCaptcha: '图形验证码错误'}, 'checkCaptcha']

      if (Array.isArray(this.rule)) {
        rule = rule.concat(this.rule)
      } else {
        rule.push(this.rule)
      }

      return rule.map(item => {
        if (item === 'required') {
          return {
            required: '请输入验证码'
          }
        }

        return item
      })
    },
    mergeCustomRule () {
      return Object.assign({
        /**
         * 验证验证码
         */
        checkCaptcha: value => {
          return new Promise((resolve, reject) => {
            this.$emit('check', value, {
              resolve: () => {
                resolve({
                  valid: true
                })
              },
              reject: message => {
                resolve({
                  valid: false,
                  message: message || '请输入正确的图形验证码'
                })
              }
            })
          })
        }
      }, this.customRule)
    },
    captchaUrl () {
      return this.src + '?' + this.guid
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    }
  },
  methods: {
    /**
     * 刷新验证码
     */
    refresh () {
      this.guid = utils.guid()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/_common";

.img-captcha-text {
  height: 42px;
  margin-bottom: 32px;

  @include mobile () {
    margin-bottom: 22px;
  }
}

img {
  height: 100%;
  border-radius: 3px;
  cursor: pointer;
}
</style>
